import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosinterceptor";

const initialState = {
  fromNudgingScreen: false,
  codesForDelete:[],
  acceptedCodes: "",
  visibleNudgeCount: 0,
   nudgingSessionResponse: {
    loading: false,
    data: {},
    error: null,
  },
   nudgingEvaluationResponse: {
    loading: false,
    data: {},
    error: null,
  },
   nudgingActionInfoResponse: {
    loading: false,
    data: {},
    error: null,
  },
  
};

// nudging_session_info_invoke_url                                         
export const nudgingSessionAPI = createAsyncThunk(
  "/nudgingSessionAPi ",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/nudging_session_info",
        payload,
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while initialize Coding Screen Session:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          " Coding Screen Session Error",
      );
    }
  },
);

// nudging_evaluation_invoke_url                                           
export const nudgingEvaluationAPI = createAsyncThunk(
  "/nudging_evaluationAPI ",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/nudging_evaluation",
        payload,
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while evaluation nudging codes:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Nudging Codes Error",
      );
    }
  },
);

// nudging_action_info_invoke_url                                                                                     
export const nudgingActionInfoAPI = createAsyncThunk(
  "/nudgingActionInfoAPI ",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/nudging_action_info",
        payload,
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error on nudging action:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Nudging Action Error",
      );
    }
  },
);




const nudginSlicer = createSlice({
  name: "nudging",
  initialState,
  reducers: {
    setFromNudgingScreen: (state, action) => {
      state.fromNudgingScreen = action.payload;
    },
   setCodesForDelete: (state, action) => {
    state.codesForDelete = {
    ...state.codesForDelete,
    ...action.payload,
  }
},
   resetNudgingEvaluationResponse: (state) => {
      state.nudgingEvaluationResponse = {
        loading: false,
        data: null,
        error: null,
      };
    },
    setVisibleNudgeCount: (state, action) => {
  state.visibleNudgeCount = action.payload;
},
  },
  extraReducers: (builder) =>
    builder
      .addCase(nudgingSessionAPI.pending, (state) => {
        state.nudgingSessionResponse.loading = true;
        state.nudgingSessionResponse.error = null;
      })
      .addCase(nudgingSessionAPI.fulfilled, (state, action) => {
        state.nudgingSessionResponse.loading = false;
        state.nudgingSessionResponse.data = action.payload;
      })
      .addCase(nudgingSessionAPI.rejected, (state, action) => {
        state.nudgingSessionResponse.loading = false;
        state.nudgingSessionResponse.error = action.payload;
      })
      .addCase(nudgingEvaluationAPI.pending, (state) => {
        state.nudgingEvaluationResponse.loading = true;
        state.nudgingEvaluationResponse.error = null;
      })
      .addCase(nudgingEvaluationAPI.fulfilled, (state, action) => {
        state.nudgingEvaluationResponse.loading = false;
        state.nudgingEvaluationResponse.data = action.payload;
      })
      .addCase(nudgingEvaluationAPI.rejected, (state, action) => {
        state.nudgingEvaluationResponse.loading = false;
        state.nudgingEvaluationResponse.error = action.payload;
      })
      .addCase(nudgingActionInfoAPI.pending, (state) => {
        state.nudgingActionInfoResponse.loading = true;
        state.nudgingActionInfoResponse.error = null;
      })
      .addCase(nudgingActionInfoAPI.fulfilled, (state, action) => {
        state.nudgingActionInfoResponse.loading = false;
        state.nudgingActionInfoResponse.data = action.payload;
      })
      .addCase(nudgingActionInfoAPI.rejected, (state, action) => {
        state.nudgingActionInfoResponse.loading = false;
        state.nudgingActionInfoResponse.error = action.payload;
      }),
});

export const {setFromNudgingScreen, setCodesForDelete,resetNudgingEvaluationResponse,setVisibleNudgeCount} =
  nudginSlicer.actions;

export default nudginSlicer.reducer;
